import React, { memo } from 'react'

import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsSmartLowPoly } from 'Pods/ThreeDStudio/Store/actions/remeshSettings'

function SmartLowPolySelector() {
  const isDisabled = useThreeDStudioStore(state =>
    state.schema?.enhancedModelSchema?.ui_schema?.smart_low_poly?.['ui:options']?.disabled
  )

  return (
    <ToggleSelector
      id="remesh-smart-low-poly"
      keyName="isSmartLowPoly"
      label="Smart low poly"
      setFunction={setIsSmartLowPoly}
      sliceName="remeshSettings"
      disabled={isDisabled}
    />
  )
}

export default memo(SmartLowPolySelector)
